import { Box, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { FunctionComponent, useEffect, useState } from 'react';
import GeneratedReportService from '../../../../../shared/services/generated-report/generatedReport.service';
import { IEsrsTable } from '../../../../../shared/services/generated-report/generated-report.model';
import { ReportingEsrsSixTableSegment } from './reporting-esrs-six-table-segment';

export const ReportingEsrsSixTable: FunctionComponent<{ reportPeriodId: string }> = ({ reportPeriodId }) => {

  const generatedReportService = new GeneratedReportService();
  const [tableData, setTableData] = useState<IEsrsTable>()

  useEffect(() => {
    generatedReportService.getEsrs(reportPeriodId)
      .then(response => {
        setTableData(response)
      })
      .catch(err => console.log(err))
  }, [])

  return (
    <Box sx={{
      mb: 2, overflowX: 'auto',
      maxWidth: '100%'
    }}>
      {tableData &&
        <TableContainer>
          <Table size="small" >
            <TableHead>
              <TableRow>
                <TableCell colSpan={1} sx={{ borderBottom: 'none' }}></TableCell>
                <TableCell colSpan={tableData.reportPeriods.previous ? 4 : 3} align="center" sx={{ borderBottom: 'none' }}>
                  <Chip label={'Emissions Data Overview'} sx={{ fontWeight: 600, fontSize: '1.15rem', color: 'primary.dark', backgroundColor: 'secondary.light' }} />
                </TableCell>
                <TableCell colSpan={4} align="center" sx={{ borderBottom: 'none' }}>
                  <Chip label={'Targets & Future Milestones'} sx={{ fontWeight: 600, fontSize: '1.15rem', color: 'text.secondary', backgroundColor: 'lightGrey.main' }} />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, fontSize: '1rem', color: 'primary.dark', borderBottomColor: 'primary.dark', borderBottomWidth: '3px', borderBottomStyle: 'solid', minWidth: '250px' }}></TableCell>
                <TableCell align="center" sx={{ fontWeight: 600, fontSize: '1rem', color: 'primary.dark', borderBottomColor: 'primary.dark', borderBottomWidth: '3px', borderBottomStyle: 'solid' }}>Base Year  {`(${tableData.reportPeriods.base})`}</TableCell>
                {tableData.reportPeriods.previous && <TableCell align="center" sx={{ fontWeight: 600, fontSize: '1rem', color: 'primary.dark', borderBottomColor: 'primary.dark', borderBottomWidth: '3px', borderBottomStyle: 'solid' }}>Previous Year { `(${tableData.reportPeriods.previous})`}</TableCell>}
                <TableCell align="center" sx={{ fontWeight: 600, fontSize: '1rem', color: 'primary.dark', borderBottomColor: 'primary.dark', borderBottomWidth: '3px', borderBottomStyle: 'solid' }}>Current Year {`(${tableData.reportPeriods.current})`}</TableCell>
                <TableCell align="center" sx={{ fontWeight: 600, fontSize: '1rem', color: 'primary.dark', borderBottomColor: 'primary.dark', borderBottomWidth: '3px', borderBottomStyle: 'solid' }}>% Change Previous</TableCell>
                <TableCell align="center" sx={{ fontWeight: 600, fontSize: '1rem', color: 'text.secondary', borderBottomColor: 'primary.dark', borderBottomWidth: '3px', borderBottomStyle: 'solid' }}>2025</TableCell>
                <TableCell align="center" sx={{ fontWeight: 600, fontSize: '1rem', color: 'text.secondary', borderBottomColor: 'primary.dark', borderBottomWidth: '3px', borderBottomStyle: 'solid' }}>2030</TableCell>
                <TableCell align="center" sx={{ fontWeight: 600, fontSize: '1rem', color: 'text.secondary', borderBottomColor: 'primary.dark', borderBottomWidth: '3px', borderBottomStyle: 'solid' }}>2050</TableCell>
                <TableCell align="center" sx={{ fontWeight: 600, fontSize: '1rem', color: 'text.secondary', borderBottomColor: 'primary.dark', borderBottomWidth: '3px', borderBottomStyle: 'solid' }}>Annual % Target / Base Year</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell scope='row' sx={{ fontWeight: 600, borderBottomColor: 'primary.dark', borderBottomWidth: '2px', borderBottomStyle: 'solid' }} >
                  Scope 1 GHG Emissions
                </TableCell>
                <TableCell colSpan={8} sx={{ borderBottomColor: 'primary.dark', borderBottomWidth: '2px', borderBottomStyle: 'solid' }}></TableCell>
              </TableRow>
              <ReportingEsrsSixTableSegment title={<>
                Gross Scope 1 GHG emissions (tCO<sub>2</sub>e)
              </>} data={tableData.scopeOne}
                showPrevious={!!tableData.reportPeriods.previous} />
              <ReportingEsrsSixTableSegment title={<>
                Percentage of Scope 1 GHG emissions from regulated emission trading schemes (%)
              </>} data={tableData.scopeOneEts} 
                showPrevious={!!tableData.reportPeriods.previous}/>
              <TableRow>
                <TableCell scope='row' sx={{ fontWeight: 600, borderBottomColor: 'primary.dark', borderBottomWidth: '2px', borderBottomStyle: 'solid', borderTopColor: 'primary.dark', borderTopWidth: '2px', borderTopStyle: 'solid' }} >
                  Scope 2 GHG Emissions
                </TableCell>
                <TableCell colSpan={8} sx={{ borderBottomColor: 'primary.dark', borderBottomWidth: '2px', borderBottomStyle: 'solid', borderTopColor: 'primary.dark', borderTopWidth: '2px', borderTopStyle: 'solid' }}></TableCell>
              </TableRow>
              <ReportingEsrsSixTableSegment title={<>
                Gross location-based Scope 2 GHG emissions (tCO<sub>2</sub>e)
              </>} data={tableData.scopeTwoLocation}
                showPrevious={!!tableData.reportPeriods.previous} />
              <ReportingEsrsSixTableSegment title={<>
                Gross market-based Scope 2 GHG emissions (tCO<sub>2</sub>e)
              </>} data={tableData.scopeTwoMarket} 
                showPrevious={!!tableData.reportPeriods.previous}/>
              <TableRow>
                <TableCell scope='row' sx={{ fontWeight: 600, borderBottomColor: 'primary.dark', borderBottomWidth: '2px', borderBottomStyle: 'solid', borderTopColor: 'primary.dark', borderTopWidth: '2px', borderTopStyle: 'solid' }} >
                  Significant Scope 3 GHG Emissions
                </TableCell>
                <TableCell colSpan={8} sx={{ borderBottomColor: 'primary.dark', borderBottomWidth: '2px', borderBottomStyle: 'solid', borderTopColor: 'primary.dark', borderTopWidth: '2px', borderTopStyle: 'solid' }}></TableCell>
              </TableRow>
              <ReportingEsrsSixTableSegment title={<>
                Gross Scope 3 GHG emissions (tCO<sub>2</sub>e)
              </>} data={tableData.scopeThree} 
                showPrevious={!!tableData.reportPeriods.previous}/>
              {tableData.scopeThree.significantScopeThree?.map(data => {
                return <ReportingEsrsSixTableSegment title={<>{`${data.groupName} `}
                  GHG emissions (tCO<sub>2</sub>e)
                </>} data={data} 
                  showPrevious={!!tableData.reportPeriods.previous}/>
              })}
              <TableRow>
                <TableCell scope='row' sx={{ fontWeight: 600, borderBottomColor: 'primary.dark', borderBottomWidth: '2px', borderBottomStyle: 'solid', borderTopColor: 'primary.dark', borderTopWidth: '2px', borderTopStyle: 'solid' }} >
                  Total GHG Emissions
                </TableCell>
                <TableCell colSpan={8} sx={{ borderBottomColor: 'primary.dark', borderBottomWidth: '2px', borderBottomStyle: 'solid', borderTopColor: 'primary.dark', borderTopWidth: '2px', borderTopStyle: 'solid' }}></TableCell>
              </TableRow>
              <ReportingEsrsSixTableSegment title={<>
                Total location-based GHG emissions (tCO<sub>2</sub>e)
              </>} data={tableData.totalLocation} 
                showPrevious={!!tableData.reportPeriods.previous}/>
              <ReportingEsrsSixTableSegment title={<>
                Total market-based GHG emissions (tCO<sub>2</sub>e)
              </>} data={tableData.totalMarket} 
                showPrevious={!!tableData.reportPeriods.previous}/>
            </TableBody>
          </Table>
        </TableContainer>}
    </Box >
  )
}